import * as React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

function forbidden(props: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
            <path
                fill="#fff"
                d="m14.083 4.656-2.734-2.733c-.32-.32-.96-.587-1.413-.587H6.069c-.453 0-1.093.267-1.413.587L1.923 4.656c-.32.32-.587.96-.587 1.413v3.867c0 .453.267 1.093.587 1.413l2.733 2.734c.32.32.96.586 1.413.586h3.867c.453 0 1.093-.266 1.413-.586l2.734-2.734c.32-.32.586-.96.586-1.413V6.069c0-.453-.266-1.093-.586-1.413Zm-3.394 5.327a.503.503 0 0 1 0 .706.494.494 0 0 1-.707 0l-1.98-1.98-1.98 1.98a.494.494 0 0 1-.707 0 .503.503 0 0 1 0-.706l1.98-1.98-1.98-1.98a.503.503 0 0 1 0-.707.503.503 0 0 1 .708 0l1.98 1.98 1.98-1.98a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .707l-1.98 1.98 1.98 1.98Z"
            />
        </svg>
    )
}

export default forbidden
